import { AgentDocumentProvider } from '../AgentDocumentProvider';
import { Headers } from '../types';
import { ApiClientFactory, ApiClientFactoryInterface } from './clients';

export class AgentDocumentProviderFactory {
  private readonly apiClientFactory: ApiClientFactoryInterface;

  constructor(baseUrl: string, headers: Headers) {
    this.apiClientFactory = new ApiClientFactory(`${baseUrl}/api/v1/agent`, headers);
  }

  public createAgentDocumentProvider(authToken: string): AgentDocumentProvider {
    return new AgentDocumentProvider(this.apiClientFactory.createAuthorizedClient(authToken));
  }
}
